module.exports = __webpack_public_path__ + "img/australia-cardiovascular-diseases-female.ec75cbc5.png";